// extracted by mini-css-extract-plugin
export default {"form":"styles_form__R7Q32","container":"styles_container__lSh3E","input":"styles_input__SfsQd","image":"styles_image__9v6+W","headerContainer":"styles_headerContainer__X-t2p"};